import { getMissingStatus } from "../services/apiMissingReport";
import { useMappedQuery } from "./queryUtils";

export function useStatusMissing({ start_date, end_date }) {
  return useMappedQuery({
    queryKey: ["status-missing"],
    queryFn: () => getMissingStatus({ start_date, end_date }),
    dataKey: "statusMissing",
  });
}
